module.exports = __webpack_public_path__ + "static/img/2.f96e160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/2.png
// module id = MFoc
// module chunks = 1